import { render, staticRenderFns } from "./GymnasticsDetailPage.vue?vue&type=template&id=787a60d8&scoped=true"
import script from "./GymnasticsDetailPage.vue?vue&type=script&lang=js"
export * from "./GymnasticsDetailPage.vue?vue&type=script&lang=js"
import style0 from "./GymnasticsDetailPage.vue?vue&type=style&index=0&id=787a60d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787a60d8",
  null
  
)

export default component.exports